import { useMutation } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

export interface ClonePayload {
  uuid: string;
  container: string;
}

export interface CloneResponse {
  data: {
    uuid: string;
    container: string;
  };
}

export function useObjectClone() {
  const { keycloak } = useKeycloak();

  return useMutation({
    mutationFn: async (payload: ClonePayload): Promise<CloneResponse> => {
      const res = await fetch(
        `${import.meta.env.VITE_CRUD_ENGINE_ENDPOINT}/bundles/crud_bundle/functions/clone`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify(payload),
        }
      );

      return res.json();
    },
  });
}
